module.exports = __webpack_public_path__ + "static/media/storage_box.73b2132e.jpg";